<template>
  <div class="f-signForm">
    <div class="title-container"><h1>{{activeLanguage.insertYourData}}</h1></div>

    <b-container fluid :class="[{'shrink-form': $store.getters.isMobileValue}, 'signatureForm']">
      <b-row class="my-3" key="textName">
        <b-col sm="12">
          <b-form-input v-model="petitionName"
                        type="text"
                        :state="isValidName"
                        :placeholder="activeLanguage.insertName"></b-form-input>
        </b-col>
      </b-row>
      <b-row class="my-3" key="textSurname">
        <b-col sm="12">
          <b-form-input v-model="petitionSurname"
                        type="text"
                        :state="isValidSurname"
                        :placeholder="activeLanguage.insertSurname"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="my-3" key="textCityName">
        <b-col sm="12">
          <multiselect v-model="petitionCity" id="ajax" label="name" track-by="name"
                       :placeholder="activeLanguage.insertCity"
                       open-direction="bottom" :options="matchedCities" :searchable="true"
                       :loading="isLoading" :internal-search="false" :clear-on-select="true" :close-on-select="true"
                       :options-limit="15" :limit="15" :max-height="200" :preserveSearch="true"
                       :show-no-results="true" @search-change="matchCityName"
                       :custom-label="nameWithIcon">
            <span slot="noResult">Oops! No elements found.</span>
          </multiselect>
        </b-col>
      </b-row>

      <b-row class="my-3" key="email">
        <b-col sm="12">
          <b-form-input v-model="petitionEmail"
                        type="email"
                        :state="isValidEmail"
                        :placeholder="activeLanguage.insertEmail"
                        id="emailForm"></b-form-input>
          <b-tooltip target="emailForm" ref="tooltipEmail" :disabled="isDisabledTooltip"
                     :title="activeLanguage.alreadyUsedEmail"></b-tooltip>
        </b-col>
      </b-row>

      <b-row class="my-1" key="receiveUpdates">
        <b-col sm="12" class="checkbox-align">
          <b-form-checkbox id="registerForUpdatesCheckbox"
                           v-model="updatesAboutPetitionStatus">
            <p class="checkbox-text">
              {{activeLanguage.updatesAboutPetition}}
            </p>
          </b-form-checkbox>
        </b-col>
      </b-row>

      <b-row class="my-1" key="privacyStatement">
        <b-col sm="12" class="checkbox-align">
          <b-form-checkbox id="privacyStatementCheckbox"
                           v-model="confirmationPrivacyStatementStatus">
            <p class="checkbox-text">
              {{activeLanguage.confirmationPrivacyStatementPT1}}<a class="privacyStatementLink" target="_blank"
                                                                   @click="openPrivacyPolicyModal">{{activeLanguage.confirmationPrivacyStatementPT2}}</a>
            </p>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="my-3 button-align" key="submitButton">
        <b-col sm="12">
          <b-button id="signButton" :disabled="!areInformationReady" @click="submitRequest">
            {{activeLanguage.signPetition}}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <privacy-policy-modal ref="privacyPolicyModal"></privacy-policy-modal>
  </div>
</template>

<script>
  import PrivacyPolicyModal from './PrivacyPolicyModal'
  import {mapGetters} from 'vuex'

  export default {
    name: 'SignForm',
    components: {PrivacyPolicyModal},
    data () {
      return {
        petitionName: '',
        petitionSurname: '',
        petitionCityName: '',
        petitionEmail: '',
        updatesAboutPetitionStatus: false,
        confirmationPrivacyStatementStatus: false,
        matchedCities: [],
        latitudeSelectedCity: '',
        longitudeSelectedCity: '',
        isCitySelected: null,
        emailAlreadyUsed: '',
        petitionCity: null,
        isLoading: false,
        previousRequest: null,
        currentLanguageCode: null,
        userNameList: ['andrea.vicari', 'leonardo.iandiorio', 'demo', 'andrea.vicari.backup'],
        userIdx: 0
      }
    },
    computed: {
      ...mapGetters([
        'currentLanguageValue'
      ]),
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      validNameRegex () {
        return /^[^±!@£$%^&*_+§¡€#¢§¶•ªº«\\/<>?:;|=.,]{1,20}$/
      },
      containNumber () {
        return /\d/
      },
      isValidName () {
        if (this.petitionName === '') {
          return null
        }
        let re = this.validNameRegex
        let reN = this.containNumber
        if (re.test(this.petitionName) && !reN.test(this.petitionName)) {
          this.petitionName = this.toTitleCase(this.petitionName)
          return true
        }
        return false
      },
      isValidSurname () {
        if (this.petitionSurname === '') {
          return null
        }
        let re = this.validNameRegex
        let reN = this.containNumber
        if (re.test(this.petitionSurname) && !reN.test(this.petitionSurname)) {
          this.petitionSurname = this.toTitleCase(this.petitionSurname)
          return true
        }
        return false
      },
      isValidEmail () {
        if (this.petitionEmail === '') {
          return null
        }
        if (this.emailAlreadyUsed !== '' && this.petitionEmail !== this.emailAlreadyUsed) {
          this.$refs.tooltipEmail.$emit('close')
        }
        if (this.emailAlreadyUsed !== '' && this.petitionEmail === this.emailAlreadyUsed) {
          this.$refs.tooltipEmail.$emit('open')
        }
        let re = /^(([^<>()[\]\\.,;:\s@]+(\.[^<>()[\]\\.,;:\s@]+)*)|(.+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(this.petitionEmail) && this.petitionEmail !== this.emailAlreadyUsed
      },
      areInformationReady () {
        return !!(this.isValidName && this.isValidSurname && this.isValidEmail && this.confirmationPrivacyStatementStatus && this.isCitySelected)
      },
      areSuggestionsPresent () {
        return this.matchedCities.length > 0
      },
      isDisabledTooltip () {
        if (this.petitionEmail === '') {
          return true
        }
        return this.petitionEmail !== this.emailAlreadyUsed
      }
    },
    methods: {
      nameWithIcon ({name}) {
        return `\uD83D\uDCCD ${name}`
      },
      openPrivacyPolicyModal () {
        this.$refs.privacyPolicyModal.showModal()
      },
      toTitleCase (str) {
        return str.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      isExistingName (alternateNames, mainName, name) {
        let isPresent = false
        let matchName = ''
        if (alternateNames) {
          alternateNames.forEach(altName => {
            let nameToCheck = altName.name.toLowerCase().replace(/’/g, ' ').replace(/'/g, ' ').replace(/-/g, ' ')
            if (nameToCheck.includes(name.replace(/’/g, ' ').replace(/'/g, ' ').replace(/-/g, ' '))) {
              isPresent = true
              matchName = altName.name
            }
          })
        }
        if (mainName && mainName.toLowerCase().replace(/’/g, ' ').replace(/'/g, ' ').replace(/-/g, ' ').includes(name.replace('\'', ' '))) {
          isPresent = true
          matchName = mainName
        }
        return [isPresent, matchName]
      },
      alreadyPresent (cityName) {
        let isPresent = false
        this.matchedCities.forEach(city => {
          if (city.name === cityName) {
            isPresent = true
          }
        })
        return isPresent
      },
      matchCityNameGeonames (formText) {
        if (formText.length > 0) {
          this.isLoading = true
          let self = this
          this.$http.get('https://secure.geonames.org/searchJSON?q=' + formText + '&maxRows=10&username=' + this.userNameList[this.userIdx] + '&style=FULL&lang=' + this.currentLanguageCode, {
            // use before callback
            before (request) {
              // abort previous request, if exists
              if (self.previousRequest) {
                self.previousRequest.abort()
              }
              // set previous request on Vue instance
              self.previousRequest = request
            }
          }).then((response) => {
            if (response.status === 200) {
              let bodyRes = response.body.geonames
              if (bodyRes) {
                for (let idx = 0; idx < bodyRes.length; idx++) {
                  if (bodyRes[idx].fclName.includes('city, village')) {
                    let alternateNames = bodyRes[idx].alternateNames
                    let mainName = bodyRes[idx].name
                    let existingMatch = this.isExistingName(alternateNames, mainName, formText.toLowerCase())
                    if (existingMatch[0]) {
                      if (!this.alreadyPresent(bodyRes[idx].toponymName + ', ' + bodyRes[idx].adminName1 + ', ' + bodyRes[idx].countryName + ' (' + existingMatch[1] + ')')) {
                        self.matchedCities.push({
                          'name': bodyRes[idx].name + ', ' + bodyRes[idx].adminName1 + ', ' + bodyRes[idx].countryName + ' (' + existingMatch[1] + ')',
                          'latitude': bodyRes[idx].lat,
                          'longitude': bodyRes[idx].lng,
                          'img': 'geonames'
                        })
                      }
                    }
                  }
                  self.isLoading = false
                }
              } else {
                this.userIdx = (this.userIdx + 1) % this.userNameList.length
                this.matchCityNameGeonames(formText)
              }
            }
            self.isLoading = false
          }
          ).catch(function (err) {
            if (err.status >= 500) {
              console.log('Server-Related problem')
              self.isLoading = false
            } else if (err.status === 400) {
              console.log('A bad request occurred')
              self.isLoading = false
            } else if (err.status === 404) {
              console.log(err.body.message)
              self.isLoading = false
            }
          })
        }
      },
      selectCity (city) {
        this.isCitySelected = true
        this.petitionCityName = city.name
        if (city.href) {
          this.retrieveLatLon(city.href)
        } else if (city.latitude && city.longitude) {
          this.latitudeSelectedCity = city.latitude
          this.longitudeSelectedCity = city.longitude
        }
        this.matchedCities = []
      },
      matchCityName (formText) {
        this.matchCityNameTeleport(formText)
      },
      matchCityNameTeleport (formText) {
        this.matchedCities = []
        if (formText.length > 0) {
          this.isLoading = true
          let self = this
          this.$http.get('https://api.teleport.org/api/cities/?search=' + formText + '&limit=5', {
            // use before callback
            before (request) {
              // abort previous request, if exists
              if (self.previousRequest) {
                self.previousRequest.abort()
              }
              // set previous request on Vue instance
              self.previousRequest = request
            }
          }).then((response) => {
            if (response.status === 200) {
              let bodyRes = response.body._embedded['city:search-results']
              for (let idx in bodyRes) {
                let fullName = bodyRes[idx]['matching_full_name']
                let cityLink = bodyRes[idx]['_links']['city:item']['href']
                self.matchedCities.push({
                  'name': fullName,
                  'href': cityLink,
                  'img': 'teleport'
                })
              }
              if (self.matchedCities.length < 5) {
                self.matchCityNameGeonames(formText)
              } else {
                self.isLoading = false
              }
            }
          }
          ).catch(function (err) {
            if (err.status >= 500) {
              console.log('Server-Related problem')
            } else if (err.status === 400) {
              console.log('A bad request occurred')
            } else if (err.status === 404) {
              console.log(err.body.message)
            }
          })
        }
      },
      retrieveLatLon (href) {
        let self = this
        this.matchedCities = []
        if (this.petitionCityName.length > 0) {
          this.$http.get(href).then((response) => {
            if (response.status === 200) {
              let bodyRes = response.body.location.latlon
              self.latitudeSelectedCity = bodyRes.latitude
              self.longitudeSelectedCity = bodyRes.longitude
            }
          }
          ).catch(function (err) {
            if (err.status >= 500) {
              console.log('Server-Related problem')
            } else if (err.status === 400) {
              console.log('A bad request occurred')
            } else if (err.status === 404) {
              console.log(err.body.message)
            }
          })
        }
      },
      submitRequest () {
        if (this.areInformationReady) {
          // let self = this
          this.$http.post(this.$PATH_NAME + 'petitions/', {
            'petitionSign': {
              'name': this.petitionName,
              'surname': this.petitionSurname,
              'email': this.petitionEmail,
              'wantsUpdates': this.updatesAboutPetitionStatus
            },
            'city': {
              'name': this.petitionCityName.replace(/ *\([^)]*\) */g, ''),
              'latitude': this.latitudeSelectedCity,
              'longitude': this.longitudeSelectedCity
            }
          }).then((response) => {
            if (response.status === 200) {
              let petitionerName = this.petitionName
              this.petitionSurname = ''
              this.petitionEmail = ''
              this.updatesAboutPetitionStatus = false
              this.confirmationPrivacyStatementStatus = false
              this.petitionName = ''
              this.petitionCityName = ''
              this.latitudeSelectedCity = ''
              this.longitudeSelectedCity = ''
              this.petitionCity = null
              this.$emit('submittedSign', petitionerName)
            }
          }
          ).catch(function (err) {
            if (err.status >= 500) {
              console.log('Server-Related problem')
            } else if (err.status === 400) {
              alert('You cannot sign more than 20 times from the same IP address')
              console.log('A bad request occurred')
            } else if (err.status === 404) {
              console.log(err.body.message)
            } else if (err.status === 409) {
              this.emailAlreadyUsed = this.petitionEmail
              this.$refs.tooltipEmail.$emit('open')
            }
          })
        }
      },
      createStyles () {
        let styleInvalid = document.createElement('style')
        styleInvalid.type = 'text/css'
        styleInvalid.innerHTML = '.invalid-city-selector { border-color: #f04124 !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleInvalid)
        let styleInvalidFocus = document.createElement('style')
        styleInvalidFocus.type = 'text/css'
        styleInvalidFocus.innerHTML = '.invalid-city-selector:focus-within  { box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleInvalidFocus)
        let styleInvalidActive = document.createElement('style')
        styleInvalidActive.type = 'text/css'
        styleInvalidActive.innerHTML = '.invalid-city-selector:active { box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleInvalidActive)

        let styleValid = document.createElement('style')
        styleValid.type = 'text/css'
        styleValid.innerHTML = '.valid-city-selector { border-color: #28a745; !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleValid)
        let styleValidFocus = document.createElement('style')
        styleValidFocus.type = 'text/css'
        styleValidFocus.innerHTML = '.valid-city-selector:focus-within  { box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25) !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleValidFocus)
        let styleValidActive = document.createElement('style')
        styleValidActive.type = 'text/css'
        styleValidActive.innerHTML = '.valid-city-selector:active { box-shadow: 0 0 0 0.2rem rgba(40,167,69,.25) !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleValidActive)

        let styleNeutral = document.createElement('style')
        styleNeutral.type = 'text/css'
        styleNeutral.innerHTML = '.neutral-city-selector { color: #495057; background-color: #fff; border: 1px solid #ced4da; border-radius: .25rem; transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out; }'
        document.getElementsByTagName('head')[0].appendChild(styleNeutral)
        let styleNeutralFocus = document.createElement('style')
        styleNeutralFocus.type = 'text/css'
        styleNeutralFocus.innerHTML = '.neutral-city-selector:focus-within  { border-color: #80bdff; box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleNeutralFocus)
        let styleNeutralActive = document.createElement('style')
        styleNeutralActive.type = 'text/css'
        styleNeutralActive.innerHTML = '.neutral-city-selector:active { border-color: #80bdff; box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25) !important; }'
        document.getElementsByTagName('head')[0].appendChild(styleNeutralActive)

        this.neutralCitySelector()
      },
      invalidCitySelector () {
        document.getElementsByClassName('multiselect__tags')[0].classList.remove('neutral-city-selector')
        document.getElementsByClassName('multiselect__tags')[0].classList.remove('valid-city-selector')
        document.getElementsByClassName('multiselect__tags')[0].classList.add('invalid-city-selector')
      },
      validCitySelector () {
        document.getElementsByClassName('multiselect__tags')[0].classList.remove('neutral-city-selector')
        document.getElementsByClassName('multiselect__tags')[0].classList.remove('invalid-city-selector')
        document.getElementsByClassName('multiselect__tags')[0].classList.add('valid-city-selector')
      },
      neutralCitySelector () {
        document.getElementsByClassName('multiselect__tags')[0].classList.remove('valid-city-selector')
        document.getElementsByClassName('multiselect__tags')[0].classList.remove('invalid-city-selector')
        document.getElementsByClassName('multiselect__tags')[0].classList.add('neutral-city-selector')
      },
      switchToLanguage () {
        switch (this.currentLanguageValue) {
          case 'Italian':
            this.currentLanguageCode = 'IT'
            break
          case 'English':
            this.currentLanguageCode = 'EN'
            break
          case 'French':
            this.currentLanguageCode = 'FR'
            break
          case 'German':
            this.currentLanguageCode = 'DE'
            break
          case 'Slovenian':
            this.currentLanguageCode = 'SL'
            break
        }
      }
    },
    mounted () {
      this.createStyles()
      this.switchToLanguage()
    },
    watch: {
      petitionCity: function (city) {
        if (city) {
          this.selectCity(city)
        } else {
          this.isCitySelected = false
          this.petitionCityName = ''
        }
      },
      isCitySelected: function (selectedValue) {
        if (selectedValue === true) {
          this.validCitySelector()
        } else if (selectedValue === false) {
          this.invalidCitySelector()
        } else if (selectedValue === null) {
          this.neutralCitySelector()
        }
      },
      currentLanguageValue: function (newVal) {
        this.switchToLanguage()
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
  .signatureForm {
    padding-left: 15%;
    padding-right: 15%;
  }

  .shrink-form {
    padding-left: 5%;
    padding-right: 5%;
  }

  .checkbox-text {
    text-align: left;
    font-size: 9pt;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
  }

  .checkbox-align {
    text-align: left;
  }

  .privacyStatementLink {
    color: #c41c21 !important;
  }

  .privacyStatementLink:hover {
    color: #c41c21 !important;
    cursor: pointer;
  }

  .icon {
    display: inline-block;
    height: 1.25em;
    background-repeat: no-repeat;
    background-size: contain;
    vertical-align: text-bottom;
  }

  .content-alignment {
    text-align: left;
    border-bottom: 1px solid rgba(128, 128, 128, 0.3);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .suggestion-container-style {
    border: 1px solid grey;
    background-color: white;
    z-index: 999;
    position: absolute;
    max-width: 93%;
    min-width: 90%;
    margin-left: 2%;
  }

  .icon-localization {
    width: 1.25em;
    padding-right: 8%;
    background-image: url("data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjY0cHgiIGhlaWdodD0iNjRweCIgdmlld0JveD0iMCAwIDQzOC41MzYgNDM4LjUzNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDM4LjUzNiA0MzguNTM2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTMyMi42MjEsNDIuODI1QzI5NC4wNzMsMTQuMjcyLDI1OS42MTksMCwyMTkuMjY4LDBjLTQwLjM1MywwLTc0LjgwMywxNC4yNzUtMTAzLjM1Myw0Mi44MjUgICBjLTI4LjU0OSwyOC41NDktNDIuODI1LDYzLTQyLjgyNSwxMDMuMzUzYzAsMjAuNzQ5LDMuMTQsMzcuNzgyLDkuNDE5LDUxLjEwNmwxMDQuMjEsMjIwLjk4NiAgIGMyLjg1Niw2LjI3Niw3LjI4MywxMS4yMjUsMTMuMjc4LDE0LjgzOGM1Ljk5NiwzLjYxNywxMi40MTksNS40MjgsMTkuMjczLDUuNDI4YzYuODUyLDAsMTMuMjc4LTEuODExLDE5LjI3My01LjQyOCAgIGM1Ljk5Ni0zLjYxMywxMC41MTMtOC41NjIsMTMuNTU5LTE0LjgzOGwxMDMuOTE4LTIyMC45ODZjNi4yODItMTMuMzI0LDkuNDI0LTMwLjM1OCw5LjQyNC01MS4xMDYgICBDMzY1LjQ0OSwxMDUuODI1LDM1MS4xNzYsNzEuMzc4LDMyMi42MjEsNDIuODI1eiBNMjcwLjk0MiwxOTcuODU1Yy0xNC4yNzMsMTQuMjcyLTMxLjQ5NywyMS40MTEtNTEuNjc0LDIxLjQxMSAgIHMtMzcuNDAxLTcuMTM5LTUxLjY3OC0yMS40MTFjLTE0LjI3NS0xNC4yNzctMjEuNDE0LTMxLjUwMS0yMS40MTQtNTEuNjc4YzAtMjAuMTc1LDcuMTM5LTM3LjQwMiwyMS40MTQtNTEuNjc1ICAgYzE0LjI3Ny0xNC4yNzUsMzEuNTA0LTIxLjQxNCw1MS42NzgtMjEuNDE0YzIwLjE3NywwLDM3LjQwMSw3LjEzOSw1MS42NzQsMjEuNDE0YzE0LjI3NCwxNC4yNzIsMjEuNDEzLDMxLjUsMjEuNDEzLDUxLjY3NSAgIEMyOTIuMzU1LDE2Ni4zNTIsMjg1LjIxNywxODMuNTc1LDI3MC45NDIsMTk3Ljg1NXoiIGZpbGw9IiM2MDYwNjEiLz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K");
  }

  .invalid-city-selector {
    border-color: #f04124 !important;
  }

  ::-webkit-input-placeholder { /* WebKit browsers */
    color: rgb(70, 76, 82);
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: rgb(70, 76, 82);
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: rgb(70, 76, 82);
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    color: rgb(70, 76, 82);
  }

  #signButton {
    background-color: #c41c21 !important;
    border-color: #c41c21 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/signPetitionPageComponents/SignForm.vue